import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useStore } from "@/stores";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_LICENSE } from "@/configs/Apis";
import { showSuccess } from "@/utils/UI";
import permissionChecker from "@/permission/PermissionChecker";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectAboutDialog',
  setup(__props, { expose }) {

const store = useStore();

const visible = ref(false);
const aboutInfo = ref<any>({ status: 1, licenseType: "FREE" });

const licenseTypes: any = {
  INVALID: "",
  FREE: "免费版, 部分功能不能使用",
  CHARGE: "收费版, 无功能限制",
};

const setAboutInfo = (data: any) => {
  let status = 1;
  if (!data.secretKey) {
    status = 4;
  } else if (data.licenseType === "INVALID") {
    status = 3;
  } else if (data.expiredDate && new Date(data.expiredDate) < new Date()) {
    status = 2;
  }

  aboutInfo.value = {
    name: store.getters.appTitle,
    version: process.env.VUE_APP_APP_VERSION,
    licenseType: data.licenseType,
    licenseTypeStr: "(" + licenseTypes[data.licenseType] + ")",
    userName: data.userName,
    expiredDate: data.expiredDate,
    machineCode: data.machineCode,
    secretKey: data.secretKey,
    status,
  };
};

const open = async () => {
  const data = await DuduAjax.get<any>(API_BIS_LICENSE);
  visible.value = true;
  setAboutInfo(data);
};

const checkLicense = async () => {
  const data = await DuduAjax.get<any>(API_BIS_LICENSE);
  setAboutInfo(data);
  if (aboutInfo.value.status > 2) {
    visible.value = true;
  }
  return data;
};

const submitSecret = async () => {
  if (!aboutInfo.value.secretKey) {
    return;
  }
  const data: any = await DuduAjax.post<any>(API_BIS_LICENSE, { secretKey: aboutInfo.value.secretKey }).catch(() => "");
  if (!data) {
    return;
  }
  showSuccess("注册成功");
  setAboutInfo(data);
};

expose({ open, checkLicense });

return { __sfc: true,store, visible, aboutInfo, licenseTypes, setAboutInfo, open, checkLicense, submitSecret, permissionChecker }
}

})